import { Box, MenuItem, Stack, TextField, Typography } from '@mui/material';
import { map, replace } from 'lodash';
import { useNavigate } from 'react-router-dom';
import ButtonBack from 'src/components/common/ButtonBack';
import ButtonWithLoading from 'src/components/common/ButtonWithLoading';
import FormBulkUploadFooter from 'src/features/AIHSCodeLabeling/FormBulkUploadFooter';
import ProcessingLoading from 'src/features/AIHSCodeLabeling/ProcessingLoading';
import { useNotification } from 'src/hooks/useNotification';
import { useMutateMappingField } from 'src/services/mutate/useMutateAILabeling';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import { SUCCESS_CODE } from 'src/utils/constants/statusCode';
import { sleep } from 'src/utils/helpers/utilities';
import { useBulkUploadSearchStore } from 'src/zustand/useAILabelingStore';

const FormBulkUploadStep2 = () => {
  const { dispatch, columns, fileId, fileURL, productName, productDescription } = useBulkUploadSearchStore();
  const { mutateAsync, isPending } = useMutateMappingField();
  const { notification } = useNotification();
  const navigate = useNavigate();

  const onMappingField = async () => {
    const res = await mutateAsync({
      file_id: fileId,
      description: productDescription,
      product_name: productName,
      file_url: fileURL,
    });
    notification(
      res,
      {
        title: 'Mapping Field Successful',
        description: 'Processing your request, please wait...',
      },
      {
        title: 'Mapping Field Failed',
        description: res.message || 'An error occurred while processing your request. Please try again later.',
      },
    );
    if (res.status_code === SUCCESS_CODE.GET) {
      await sleep(3000);
      dispatch(3, 'step');
      navigate(replace(AuthRouteKeys.AIHSCodeBulkResult, ':id', fileId));
    }
  };

  if (isPending) return <ProcessingLoading onDone={() => {}} />;

  return (
    <Box>
      <ButtonBack onClick={() => dispatch(1, 'step')} to={AuthRouteKeys.AIHSCodeSearch} />

      <Typography mt={6} color={'primary.main'} variant="h6">
        Step 2:{' '}
        <Typography display={'inline'} variant="h6" color={'text.primary'}>
          Match Your Product Fields
        </Typography>
      </Typography>

      <Typography color={'textTertiary.main'} variant="body2">
        The system automatically matches the product description with the relevant HS Code(s).
      </Typography>

      <Stack mt={3} spacing={3}>
        <TextField
          required
          value={productDescription}
          onChange={(e) => dispatch(e.target.value, 'productDescription')}
          label={'Product Description'}
          size="small"
          fullWidth
          select
        >
          {map(columns, (column) => (
            <MenuItem key={column} value={column}>
              {column}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          value={productName}
          onChange={(e) => dispatch(e.target.value, 'productName')}
          label={'Additional Column'}
          size="small"
          fullWidth
          select
        >
          {map(columns, (column) => (
            <MenuItem key={column} value={column}>
              {column}
            </MenuItem>
          ))}
        </TextField>
      </Stack>

      <ButtonWithLoading
        isLoading={isPending}
        onClick={onMappingField}
        fullWidth
        sx={{ mt: 6, height: 42 }}
        size="large"
        isRounded
        variant="contained"
      >
        View Result
      </ButtonWithLoading>

      <FormBulkUploadFooter />
    </Box>
  );
};

export default FormBulkUploadStep2;
